export const dispatchElementEvent = (element, eventName, options = {
    bubbles: true,
    cancelable: true,
}) => {
    const event = new Event(eventName, options);
    element.dispatchEvent(event);
};
